"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _get = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/get"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

require("proxy-polyfill/proxy.min.js");

var _virtualObjects = _interopRequireDefault(require("./polyfill/virtualObjects"));

var _genDynamicFnName = _interopRequireDefault(require("./tools/genDynamicFnName"));

var _invokeParsedScheme = _interopRequireDefault(require("./tools/invokeParsedScheme"));

var _env = _interopRequireDefault(require("./tools/env"));

var _event = _interopRequireDefault(require("./tools/event"));

var _canIUse = _interopRequireDefault(require("./tools/canIUse"));

/**
 * @file index.ts
 * Created by wangning25 on 2021/10/05.
 */
var moduleName = 'bdmedialive';
var subModule = {
  env: _env.default,
  canIUse: _canIUse.default,
  on: _event.default.on.bind(_event.default),
  off: _event.default.off.bind(_event.default),
  eventNames: _event.default.eventNames.bind(_event.default),
  canOnNames: _event.default.canOnNames // 可以通过bmls.on监听的事件名列表

};
var virtualSubModule = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _virtualObjects.default), subModule);
var bmls = new Proxy(virtualSubModule, {
  get: function get(target, subModuleName, receiver) {
    // 访问目标对象显示声明存在的属性
    if (subModuleName in subModule) {
      return (0, _get.default)(target, subModuleName, receiver);
    } // 访问目标对象不存在的属性


    return new Proxy(virtualSubModule[subModuleName], {
      get: function get(target, actionName) {
        /**
         * bmls（bdMediaLiveScheme）调用入口
         *
         * 一级回调的处理
         * 共两种方式：
         * 第一种：once callback，不需要指定，bmls自动补全，回调成功后，自动删除，调用方通过await获取callback数据
         * 第二种：middleware callback，需要调用方通过传入回调中间件函数，调用方通过await获取中间件通过done函数回传的数据
         *
         * 二级回调的处理
         * 共一种方式：调用方在params.*中自行指定，callback函数名称随各端能力自行约定，sdk暂不做统一限定
         *
         * @param params 端能力参数
         * @param callbackMiddleware 一级回调中间件函数
         * @returns {Promise<callbackResponseType>}
         */
        return /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(params, callbackMiddleware) {
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return (0, _invokeParsedScheme.default)({
                      protocol: 'bmls://',
                      moduleName: moduleName,
                      subModuleName: subModuleName,
                      actionName: actionName,
                      params: params,
                      callbackName: (0, _genDynamicFnName.default)(actionName)
                    }, callbackMiddleware);

                  case 2:
                    return _context.abrupt("return", _context.sent);

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }();
      }
    });
  }
});
var _default = bmls;
exports.default = _default;